import React from "react";

const ServiceNowQuestion = ({
  question,
  details,
  requiredQuestion,
  label,
  optionalClass,
}) => {
  const questionClass = `usa-label service-now-question ${optionalClass}`;
  const descriptionClass = `service-now-description ${optionalClass}`;
  return (
    <label htmlFor={label}>
      <div className={questionClass}>
        <span dangerouslySetInnerHTML={{ __html: question }} />
        {requiredQuestion ? (
          <span className="service-now-asterisk">*</span>
        ) : null}
      </div>
      <div className="break"></div>
      {details !== "" ? (
        <div
          className={descriptionClass}
          dangerouslySetInnerHTML={{ __html: details }}
        />
      ) : (
        <></>
      )}
    </label>
  );
};

export default ServiceNowQuestion;
